export function getPromoCodesList(locationId: string | undefined) {
	return {
		method: 'GET',
		url: `${process.env.REACT_APP_ORIGIN}/promocodes/promoCodesForCSTable?pageSize=100&offSet=0&shouldIncludeExpiredPromoCodes=false&locationId=${locationId}`,
	}
}